
import React, { useState } from "react";
import ManualPage from "./pages/ManualPage";
import BatchPage from "./pages/BatchPage";
import HomePage from "./pages/HomePage";
import ExportPage from "./pages/ExportPage";
import UpdateDescriptionPage from "./pages/UpdateDescriptionPage";
import TelemetryPage from "./pages/TelemetryPage";

type TabType = "home" | "manual" | "batch" | "export" | "update" | "telemetry";

const App: React.FC = () => {
  const [activeTab, setActiveTab]           = useState<TabType>("home");
  const [exportFilename, setExportFilename] = useState<string>("");
  const [exportThreadId, setExportThreadId] = useState<string>("");

  const handleGoToExport = (filename: string, thread_id: string) => {
    setExportFilename(filename);
    setExportThreadId(thread_id);
    setActiveTab("export");
  };

  return (
    <div style={styles.appContainer}>

      {/* ── Top Navigation Bar ── */}
      <nav style={styles.navbar}>
        <div style={styles.navBrand}>
          <img src="/accenture_logo.svg" alt="Accenture" style={styles.accentureLogo} />
          <span style={styles.navDivider} />
          OMNI - AI based unstructured cataloging solution
        </div>
        <div style={styles.navTabs}>
          <button style={activeTab === "home"   ? styles.tabActive : styles.tab} onClick={() => setActiveTab("home")}>🏠 Home</button>
          <button style={activeTab === "batch"  ? styles.tabActive : styles.tab} onClick={() => setActiveTab("batch")}>🗂 Batch Scan</button>
          <button style={activeTab === "manual" ? styles.tabActive : styles.tab} onClick={() => setActiveTab("manual")}>📄 Manual Upload</button>
          <button style={styles.tabDisabled} disabled title="Coming soon">🚀 Upload to Alation</button>
          <button style={activeTab === "telemetry" ? styles.tabActive : styles.tab} onClick={() => setActiveTab("telemetry")}>📊 Telemetry</button>
        </div>
      </nav>

      {/* ── Page Content ── */}
      <main style={styles.main}>
        {activeTab === "home"      && <HomePage onNavigate={(tab: string) => setActiveTab(tab as TabType)} />}
        {activeTab === "manual"    && <ManualPage onGoToExport={handleGoToExport} />}
        {activeTab === "batch"     && <BatchPage />}
        {activeTab === "export"    && <ExportPage filename={exportFilename} thread_id={exportThreadId} onBack={() => setActiveTab("manual")} />}
        {activeTab === "update"    && <UpdateDescriptionPage />}
        {activeTab === "telemetry" && <TelemetryPage />}
      </main>

      {/* ── Footer ── */}
      <footer style={styles.footer}>
        <p>Data Cataloging Solution © 2026</p>
      </footer>

    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  appContainer: { minHeight: "100vh", display: "flex", flexDirection: "column", backgroundColor: "#f0f2f5", fontFamily: "Segoe UI, Arial, sans-serif" },
  navbar:       { backgroundColor: "#1565c0", color: "#fff", padding: "0 32px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 60, boxShadow: "0 2px 8px rgba(0,0,0,0.2)" },
  navBrand:     { fontSize: 20, fontWeight: "bold", letterSpacing: 1, display: "flex", alignItems: "center", gap: 16 },
  accentureLogo: { height: 42, width: "auto" },
  navDivider:    { width: 1, height: 32, background: "rgba(255,255,255,0.3)", display: "inline-block" },
  navTabs:      { display: "flex", gap: 8 },
  tab:          { padding: "8px 20px", background: "transparent", color: "#90caf9", border: "1px solid #90caf9", borderRadius: 6, cursor: "pointer", fontSize: 14, fontWeight: "normal" },
  tabActive:    { padding: "8px 20px", background: "#fff", color: "#1565c0", border: "1px solid #fff", borderRadius: 6, cursor: "pointer", fontSize: 14, fontWeight: "bold" },
  tabDisabled:  { padding: "8px 20px", background: "transparent", color: "rgba(255,255,255,0.35)", border: "1px solid rgba(255,255,255,0.35)", borderRadius: 6, cursor: "not-allowed", fontSize: 14, fontWeight: "normal" },
  main:         { flex: 1, padding: "32px 16px" },
  footer:       { textAlign: "center", padding: "16px", backgroundColor: "#1565c0", color: "#90caf9", fontSize: 13 },
};

export default App;